<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_40002797_3221)">
    <path d="M10.4947 3.49829L4.08124 9.9118L1.16602 6.99657" stroke="black" stroke-opacity="0.6" stroke-width="1.16609" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.827 5.83044L8.45416 10.2033L7.57959 9.32872" stroke="black" stroke-opacity="0.6" stroke-width="1.16609" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_40002797_3221">
      <rect width="13.9931" height="13.9931" fill="white"/>
    </clipPath>
  </defs>
</svg>
